/* eslint-disable react/jsx-indent-props */
/* eslint-disable no-unused-vars */
import React, { useContext, useMemo, useCallback } from 'react';
import {
    Box, FormControl, MenuItem, InputLabel, OutlinedInput,
} from '@mui/material';
import PropTypes from 'prop-types';
import Select from '@mui/material/Select';
import useQlikSessionObject from 'hooks/useQlikSessionObject';
import { css, styled } from '@mui/system';
import AppContext from '../../AppContext';

const FilterWrapper = styled(Box, {})(({ theme }) => ({
    width: '200px',
    '.Mui-selected': {
        backgroundColor: theme.palette.green.main,
        color: 'white',
    },
}));

// const selectedStyle = (theme) => css`
//   background-color: ${theme.palette.green.main};
// `;

// const excludedStyle = (theme) => css`
//   background-color: ${theme.palette.gray.main};
// `;

const Filter = ({ field }) => {
    const { qlikApp } = useContext(AppContext);

    const qFilter = useQlikSessionObject({
        app: qlikApp,
        properties: {
            qListObjectDef: {
                qDef: {
                    qFieldDefs: [`[${field}]`],
                },
                qFrequencyMode: 'V',
            },
        },
    });

    const options = useMemo(() => {
        if (!qFilter.layout) return [];
        return qFilter.layout.qListObject.qDataPages[0].qMatrix.map((row) => ({
            qElemNumber: row[0].qElemNumber,
            qState: row[0].qState,
            qText: row[0].qText,
            qFrequency: row[0].qFrequency,
        }));
    }, [qFilter]);

    const selected = useMemo(() => {
        if (!qFilter.layout) return [];
        return qFilter.layout.qListObject.qDataPages[0].qMatrix
            .filter((row) => row[0].qState === 'S')
            .map((row) => row[0].qElemNumber);
    }, [qFilter.layout]);

    const handleChange = useCallback((event) => {
        if (!qFilter.model) return;

        const { target: { value } } = event;

        qFilter.model.selectListObjectValues('/qListObjectDef', value, false);
    }, [qFilter.model]);

    return (
        <FilterWrapper>
            <Box sx={{ minWidth: 120 }}>
                <FormControl fullWidth sx={{ width: 200, maxWidth: 300 }} size="small">
                    <InputLabel id={`${field}-filterSelection`}>{field}</InputLabel>
                    <Select
                        labelId={`${field}-filterSelection`}
                        id={`${field}-select`}
                        multiple
                        value={selected}
                        onChange={handleChange}
                        input={<OutlinedInput label={field} />}
                    >
                        {options.map((row) => (
                            (row.qState !== 'X' && (
                                <MenuItem
                                    key={row.qElemNumber}
                                    value={row.qElemNumber}
                                    name={row.qText}
                                    sx={{ width: '100%', maxWidth: '100%' }}
                                >
                                    {row.qText}
                                </MenuItem>
                            ))
                        ))}
                        {options.map((row) => (
                            (row.qState === 'X' && (
                                <MenuItem
                                    key={row.qElemNumber}
                                    value={row.qElemNumber}
                                    name={row.qText}
                                    sx={{
                                        backgroundColor: '#ddd', width: '100%', maxWidth: '100%',
                                    }}
                                >
                                    {row.qText}
                                </MenuItem>
                            ))
                        ))}
                    </Select>
                </FormControl>
            </Box>
        </FilterWrapper>
    );
};

Filter.propTypes = {
    field: PropTypes.string.isRequired,
};

export default Filter;
